<dx-popup
    #glBatchSummary
    minWidth="150px"
    minHeight="150px"
    width="65%"
    height="60%"
    title="Batch Summary"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="closePopup()"
>
    <div *dxTemplate="let item of 'content'">
        <dx-box height="100%" width="100%" direction="col" class="al-batch-summary-box">
            <dxi-item baseSize="auto">
                <dx-form width="100%" height="100%" [colCount]="4" [labelLocation]="defaultLabelLocation">
                    <dxi-item>
                        <dxo-label text="Batch #"></dxo-label>
                        <div *dxTemplate>
                            <strong>{{ glBatchSummaryData?.batchId }}</strong>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            <strong>{{ glBatchSummaryData?.postDate | date: dateFormat }}</strong>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="2">
                        <dxo-label text="Batch Name"></dxo-label>
                        <div *dxTemplate>
                            <strong>{{ glBatchSummaryData?.batchName }}</strong>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty" [colSpan]="4"></dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1">
                <dx-data-grid
                    height="95%"
                    [dataSource]="glBatchSummaryData.items"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                >
                    <dxi-column caption=" " alignment="right" cellTemplate="itemNumber"></dxi-column>
                    <dxi-column caption="GL Account" dataField="glAccountDisplayText" dataType="string"></dxi-column>
                    <dxi-column
                        caption="Debit"
                        dataField="debitAmount"
                        dataType="number"
                        [format]="currencyFormat"
                        cellTemplate="hyperlinkTemplate"
                    ></dxi-column>
                    <dxi-column
                        caption="Credit"
                        dataField="creditAmount"
                        dataType="number"
                        [format]="currencyFormat"
                        cellTemplate="hyperlinkTemplate"
                    ></dxi-column>
                    <dxi-column caption="Description" dataField="description" dataType="string"></dxi-column>

                    <div *dxTemplate="let item of 'itemNumber'">
                        <span>
                            {{ item.row.rowIndex + 1 }}
                        </span>
                    </div>

                    <div *dxTemplate="let row of 'hyperlinkTemplate'">
                        <app-hyperlink-creator
                            *ngIf="row.value !== 0"
                            [displayText]="row.value | ccCurrency"
                            (onLinkClick)="onAmountClick(row.data)"
                        ></app-hyperlink-creator>
                    </div>

                    <dxo-summary [calculateCustomSummary]="calculateCustomSummary">
                        <dxi-total-item
                            name="debitAmount"
                            showInColumn="debitAmount"
                            summaryType="custom"
                            dataType="number"
                            displayFormat="Total: {0}"
                            [valueFormat]="currencyFormat"
                        ></dxi-total-item>
                        <dxi-total-item
                            name="creditAmount"
                            showInColumn="creditAmount"
                            summaryType="custom"
                            dataType="number"
                            displayFormat="Total: {0}"
                            [valueFormat]="currencyFormat"
                        ></dxi-total-item>
                    </dxo-summary>
                </dx-data-grid>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                text="Close"
                                [icon]="iconClose"
                                type="default"
                                (onClick)="closePopup()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#glBatchSummary' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-gl-batch-detail
    *ngIf="showGLBatchDetail"
    [visible]="showGLBatchDetail"
    [glBatchDetailParam]="glBatchDetailParam"
    (closeGLBatchDetail)="showGLBatchDetail = false"
></app-gl-batch-detail>
